import { render, staticRenderFns } from "./NewsletterRegistrationForm.vue?vue&type=template&id=1c78ec64"
import script from "./NewsletterRegistrationForm.vue?vue&type=script&lang=js"
export * from "./NewsletterRegistrationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports